import React from 'react';
/*import { toast } from 'react-toastify';

import FilterComponent from '../../../../../asset/simple_asset/helper/component/FilterComponent.js';*/
import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';
/*import iconMaping from '../../../../../utils/IconMaping.js';*/
import UserRow from './UserRow.js';
import windowStop from '../../../../../utils/windowStop.js';

/*const iconCollections = {
  'iconAsc':'icon-sort fa fa-sort-asc',
  'iconDesc':'icon-sort fa fa-sort-desc',
}*/

export default class UserList extends React.Component {
  constructor() {
    super();
    this.initialState = {      
      rawData              : [],
      loadingLoadMore      : true,
      NewRowElement        : null,
      Total                : null,
      NextPage             : null,
      tenantId 						 : null,
    }
    this.state = Object.assign({}, this.initialState)
    this.loading = true;

    this.ReadSuccess = this.ReadSuccess.bind(this)
    this.ReadFailed  = this.ReadFailed.bind(this)
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (
        <UserRow 
        	self={this}
        	RowData={val}
        	history={this.props.history}
        	key={index}/>
      )
    })
    return element;
  }

  onRead(action) {
    Presenter.UserList(
      RequestProperties.UserList(action, this, this.ReadSuccess, this.ReadFailed)
    )
  }

  ReadSuccess(params, response) {
    if(params.action === 'Read') {
      this.loading = false;
      this.setState({
        loadingLoadMore: false,
        Total     : response.data.count,    
        NextPage  : response.data.next,
        rawData   : response.data.results,
      })

    } else {
      this.loading = false;
      this.setState({
        loadingLoadMore: false,
        Total     : response.data.count,    
        NextPage  : response.data.next,
        rawData   : [...this.state.rawData, ...response.data.results],
      })
    }
  }

  ReadFailed(params, error) {

  }

  componentDidMount() {
    this.onRead("Read")
  }

  componentWillUnmount() {
    windowStop()
  }

  LoadMore() {        
    this.setState({loadingLoadMore: true})
    this.onRead("Next")
  }

  RenderLoadMoreButton() {
    if(this.state.loadingLoadMore) {
      return(
        <div>
          <button className="btn btn-default" disabled><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Loading</button>
        </div>
      )
    } else {
      if(this.state.NextPage !== null) {
        return (
          <div>
            <button className="btn btn-primary" onClick={()=> {this.LoadMore()}}>Load More</button>
          </div>
        )
      }
    }
  }

  RenderRowElement() {
    if(this.loading) {
      return (        
        <tr>
          <td className="table-loading-inside" colSpan="100%">Loading data . . .</td>
        </tr>
      )
  } else if(this.state.rawData.length > 0) {
    return (this.generateRow(this.state.rawData))
  } else {
      return (
        <tr>
          <td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;Data Empty</td>
        </tr>
      )
    }
  }

  render() {
    /*const {activeToggle} = this.state*/

    return (
      <div>
        <div className="table-wrapper">
          <table className="table table-hover table-outline mb-0 m-top-15">
            <thead className="thead-default">
              <tr>
                <th>
                  Users
                </th>
               {/* <th>
                  First Name
                </th>
                <th>
                  Last Name
                </th>
                <th>
                  Phone
                </th>
                <th>
                  City
                </th>
                <th className="text-center">
                  Role
                </th>*/}
              </tr>
            </thead>
            <tbody>
              {this.RenderRowElement()}
            </tbody>
          </table>
        </div>
        <div className="row m-top-15">
          <div className="col-md-12 text-center">
            {this.RenderLoadMoreButton()}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/tenant/tenant/helper/component/UserList/UserList.js